export const marginLeftRitght = '16.5vw'
export const widthMobile = '1055px'